module.exports = __webpack_public_path__ + "img/product.7978f601.svg";